import { render, staticRenderFns } from "./PreventionistLimits.vue?vue&type=template&id=27682634&scoped=true&"
import script from "./PreventionistLimits.vue?vue&type=script&lang=js&"
export * from "./PreventionistLimits.vue?vue&type=script&lang=js&"
import style0 from "./PreventionistLimits.vue?vue&type=style&index=0&id=27682634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27682634",
  null
  
)

export default component.exports